var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OffersTable',[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t("LIST_OFFERS.SUB_TITLE")))])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }